import './style.scss'

import React from 'react'
import { AiFillGithub, AiFillMail, AiFillHome } from 'react-icons/ai'

export function Contact() {

    return <div className='contact'>
        <h4>Contact</h4>
        <div className='links'>
            <a className='item' href='https://github.com/ASportsV/iBall/tree/main' target="_blank" rel="noreferrer">
                <AiFillGithub style={{ transform: 'scale(1.5)' }}></AiFillGithub>
            </a>
            <a className='item' href='mailto:ztchen@seas.harvard.edu' target='_blank' rel='noreferrer'>
                <AiFillMail style={{ transform: 'scale(1.5)' }}></AiFillMail>
            </a>
            <a className='item' href='https://chenzhutian.org' target="_blank" rel="noreferrer">
                <AiFillHome style={{ transform: 'scale(1.5)' }}></AiFillHome>
            </a>
        </div>
    </div>
}